import React from 'react';
import { IoMdHelpCircle } from 'react-icons/io';

import './HelpBlock.scss';

function HelpBlock(props) {
    return (
        <div className="HelpBlock">
            <span className="icon">
                <IoMdHelpCircle />
            </span>
            <div className="content">
                {props.children}
            </div>
        </div>
    )
}

export default HelpBlock;